import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { FlexBox, FlexItem } from '@codex-brightworld/basics';
import { Device } from '@codex-brightworld/gadgets';
import { Icon } from '@codex-brightworld/icons';
import Product from '../Product';

export const PlusWrapper = styled(FlexItem)`
  align-self: ${props => (props.fixAlignment ? 'flex-start' : 'center')};
  flex-basis: 9%;
  margin-top: ${props => (props.fixAlignment ? '-5px' : 0)};
`;

export const Plus = styled(Icon).attrs({ icon: 'plus' })`
  display: block;
  width: 24px;
  height: 24px;
  margin: -2px auto;
  stroke: none;
  
  @media ${props => props.theme.breakpoints.mobile} {
    margin-top: 9px;
    margin-bottom: 10px;
  }
`;

const ProductList = (props) => {
  const hasOddCountOfAddons = props.addons.length % 2 === 0;

  return (
    <Device>
      {({ isMobile, isDesktop, isDesktopWide }) => (
        <FlexBox
          alignItems={isMobile ? 'stretch' : 'center'}
          direction={isMobile ? 'column' : 'row'}
        >
          <FlexItem
            basis={{
              default: '46.5%',
              mobile: '100%',
              desktopWide: hasOddCountOfAddons ? '31.3333%' : undefined
            }}
          >
            <Product
              imageUrl={props.mainProduct.imageUrl}
              imageWidth={isDesktop ? 69 : 79}
              imageHeight={isDesktop ? 60 : 70}
              hint={props.mainProductHint}
              link={props.mainProduct.link}
              title={props.mainProduct.name}
            />
          </FlexItem>

          {!isMobile && (
            <FlexItem basis="6%">
              <Plus />
            </FlexItem>
          )}

          <FlexItem
            basis={{
              default: '47.5%',
              mobile: '100%',
              desktopWide: hasOddCountOfAddons ? '63.6666%' : undefined
            }}
          >
            <FlexBox
              alignItems="stretch"
              direction="row"
              wrap="wrap"
            >
              {props.addons.map((addon, i) => (
                <Fragment key={addon.id}>
                  <FlexItem
                    basis={{
                      desktopWide: hasOddCountOfAddons ? '44.5%' : '100%',
                      default: '100%'
                    }}
                  >
                    {isMobile && <Plus />}
                    <Product
                      imageUrl={addon.imageUrl}
                      imageWidth={isDesktop ? 69 : 79}
                      imageHeight={isDesktop ? 60 : 70}
                      link={addon.link}
                      title={addon.name}
                    />
                  </FlexItem>

                  {isDesktopWide && hasOddCountOfAddons && i % 2 === 0 && (
                    <PlusWrapper fixAlignment={props.addons.length % 4 === 0}>
                      {(props.addons.length === 2 || i === 2) && <Plus />}
                    </PlusWrapper>
                  )}
                </Fragment>
              ))}
            </FlexBox>
          </FlexItem>
        </FlexBox>
      )}
    </Device>
  );
};

ProductList.propTypes = {
  addons: PropTypes.arrayOf(PropTypes.shape(Product.propTypes)),
  mainProduct: PropTypes.shape(Product.propTypes),
  mainProductHint: PropTypes.string
};

ProductList.defaultProps = {
  addons: [],
  mainProduct: PropTypes.shape(Product.defaultProps),
  mainProductHint: ''
};

export default ProductList;
